import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Small "i" control next to a price/label. Tap (touch) or click (desktop) opens a short plain
// explanation. Nothing is shown unless `text` is provided.
export default function InfoDot({ text, label, testId }) {
  if (!text) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label ? `Why: ${label}` : "More info"}
          data-testid={testId}
          onClick={(e) => e.stopPropagation()}
          className="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full text-muted-foreground transition hover:text-primary"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 text-xs leading-relaxed" onClick={(e) => e.stopPropagation()}>
        {label ? <p className="mb-1 font-semibold text-foreground">{label}</p> : null}
        <p className="text-muted-foreground">{text}</p>
      </PopoverContent>
    </Popover>
  );
}
